<template>
  <div class="work_detail">
    <div :class="MAIN_CLASS">
      <!-- bread -->
      <div class="bread_nav clearfix">
        <div class="return clearfix" @click="$router.go(-1)">
         <img v-if="URL_MAQIN==2" src="../assets/img/kjc返回.png" alt />
          <img  v-if="URL_MAQIN==1"  src="../assets/img/返回.png" alt />
          返回上一页
        </div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item to="/">我的课堂</el-breadcrumb-item>
          <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content_box clearfix">
        <div class="content_box_r">
          <div class="exam_title">{{title}}</div>
          <div class="exam_list" v-for="(item,index) in class_list" :key="index">
            <div class="exam_list_box clearfix">
              <div class="exam_list_l" @click="tab_show(index,item)"  v-if="item.is_lock==1">
                <div class="name">{{item.title}}</div>
                <div class="tag" v-if="item.son.length>0">
                  <img v-if="item.show" src="../assets/img/上.png" alt />
                  <img v-else src="../assets/img/下.png" alt />
                </div>
              </div>
              <div class="exam_list_l" v-else >
                <div class="name">{{item.title}}</div>
                <div class="tag" v-if="item.son.length>0">
                  <img v-if="item.show" src="../assets/img/上.png" alt />
                  <img v-else src="../assets/img/下.png" alt />
                </div>
              </div>
              <div class="operate clearfix" v-if="item.is_lock==1">
                <div class="number">
                  <span>{{item.logic_content.data.redo_count}}</span>
                  /{{item.logic_content.data.item_count||item.logic_content.data.RuleDataCount||0}}
                  <!-- RuleDataCount -->
                </div>
                <div
                  class="btn huang"
                  v-if="item.logic_content.data.redo_count>0"
                  @click="make1_question(item)"
                >继续</div>
                <div v-else class="btn haung" @click="make1_question(item)">做题</div>
              </div>
              <div class="operate clearfix" v-else>{{item.lock_mark}}</div>
            </div>
            <div class="exam_list_child" v-if="item.show">
              <div class="child_list clearfix" v-for="(item1,index) in item.son" :key="index">
                <div class="child_name">{{item1.title}}</div>
                <div class="btn_box" v-if="item1.is_lock==1" >
                  <div class="number">
                    <span>{{item1.logic_content.data.redo_count}}</span>
                    /{{item1.logic_content.data.RuleDataCount}}
                  </div>
                  <div
                    class="btn"
                    v-if="item1.logic_content.data.redo_count>0"
                    @click="make_question(item1)"
                  >继续</div>
                  <div
                    class="btn"
                    v-else-if="item1.logic_content.data.redo_count==0"
                    @click="make_question(item1)"
                  >做题</div>
                </div>
                <div class="btn_box" v-else>
                  {{item1.lock_mark}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Queschild, ClassTitle } from "@/api/index";
export default {
  data() {
    return {
      MAIN_CLASS:this.GLOBAL.MAIN_CLASS, //类名
      URL_MAQIN:this.GLOBAL.PLATFORM,
      class_list: [], //列表
      title: "",
      is_type: "",
      title_list: [], //标题
      id: "",
      levelList: {}
    };
  },
  mounted() {
    this.title = this.$route.query.title;
    // console.log(this.$route.query.course_id);
    this.request(this.$route.query.course_id, this.$route.query.id);
  },
  methods: {
    request(course_id, id) {
      Queschild(course_id, id).then(res => {
        let class_list = res;
        this.is_type = class_list[0].type;
        console.log(this.is_type);
        for (let i = 0; i < class_list.length; i++) {
          class_list[i].show = false;
        }
        this.class_list = class_list;
      });
    },
    
    // 点击显示隐藏
    tab_show(index, item) {
      let arr = this.class_list;
      if (item.son.length == 0) {
      } else {
        for (let i = 0; i < arr.length; i++) {
          if (index == i) {
            arr[i].show = !arr[i].show;
          }
        }
        this.class_list = arr;
      }
    },

    // 点击做题
    make1_question(item) {
      if (item.logic_content.data.redo_count > 0) {
        this.$router.push({
          path: "exercise",
          query: {
            course_id: item.logic_content.data.params?item.logic_content.data.params.course_id:item.logic_content.data.course_id,
            chapter_id: item.logic_content.data.params?item.logic_content.data.params.chapter_id:item.logic_content.data.chapter_id,
            rule_tag: item.logic_content.temp_type,
            cid: item.logic_content.data.params?item.logic_content.data.params.cid:item.logic_content.data.cid,
            course_chapter_id:item.id
          }
        });
      } else {
        this.$router.push({
          path: "exercise",
          query: {
            course_id: item.logic_content.data.params?item.logic_content.data.params.course_id:item.logic_content.data.course_id,
            chapter_id: item.logic_content.data.params?item.logic_content.data.params.chapter_id:item.logic_content.data.chapter_id,
            rule_tag: item.logic_content.temp_type,
            course_chapter_id:item.id
          }
        });
      }
    },
    // 点击子做题
    make_question(item) {
      if (item.logic_content.data.redo_count > 0) {
        console.log(item.logic_content.data.redo_count);
        this.$router.push({
          path: "exercise",
          query: {
            course_id: item.logic_content.data.params.course_id,
            chapter_id: item.logic_content.data.params.chapter_id,
            rule_tag: item.logic_content.temp_type,
            cid: item.logic_content.data.params.cid,
            course_chapter_id:item.id
          }
        });
      } else {
        console.log(item.logic_content.data.redo_count);

        this.$router.push({
          path: "exercise",
          query: {
            course_id: item.logic_content.data.params.course_id,
            chapter_id: item.logic_content.data.params.chapter_id,
            rule_tag: item.logic_content.temp_type,
            course_chapter_id:item.id
          }
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.main_mfd {
  .bread_nav {
    padding: 12px 0 12px 74px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(238, 238, 238, 1);
    margin-bottom: 16px;
    .return {
      font-size: 16px;
      font-weight: 500;
      color: rgba(43, 43, 43, 1);
      float: left;
      margin-right: 45px;
      line-height: 28px;
      cursor: pointer;
      img {
        float: left;
        width: 28px;
        height: 28px;
        margin-right: 12px;
      }
    }
    .el-breadcrumb {
      float: left;
      margin-top: 8px;
    }
  }
  .content_box {
    .content_box_l {
      float: left;
      width: 268px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      .content_box_l_title {
        padding: 24px 0;
        border-bottom: 1px solid #eee;
        text-align: center;
        font-size: 20px;
        font-weight: 500;
        color: rgba(43, 43, 43, 1);
        margin-bottom: 20px;
      }
      .class_list {
        padding: 20px 0;
        text-align: center;
        font-size: 16px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        cursor: pointer;
      }
      .active {
        font-weight: 500;
        color: rgba(43, 43, 43, 1);
        background: rgba(250, 220, 30, 1);
      }
    }
    .content_box_r {
      float: right;
      padding: 0 50px 50px 50px;
      width: 1268px;
      background: rgba(255, 255, 255, 1);
      border-radius: 4px;
      border: 1px solid rgba(238, 238, 238, 1);
      .exam_title {
        font-size: 20px;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        padding: 24px 0;
        border-bottom: 1px solid #eee;
      }
      .exam_list {
        border-bottom: 1px solid #eee;
        .exam_list_box {
          padding: 30px 0;
          .exam_list_l {
            cursor: pointer;
            .tag {
              float: left;
              width: 23px;
              height: 23px;
              background: rgba(238, 238, 238, 1);
              border-radius: 50%;
              // margin-right: 11px;
              margin-left: 11px;
              text-align: center;
              line-height: 23px;
              img {
                width: 12px;
                height: 12px;
              }
            }
            .name {
              float: left;
            }
          }

          .operate {
            float: right;
            .btn {
              cursor: pointer;
              width: 72px;
              height: 25px;
              background: rgba(0, 69, 96, 0.04);
              border-radius: 4px;
              border: 1px solid rgba(204, 204, 204, 1);
              font-size: 12px;
              font-weight: 500;
              color: rgba(0, 0, 0, 1);
              text-align: center;
              line-height: 25px;
              float: left;
              margin-left: 24px;
            }
            .huang {
              background-color: #fadc1e;
              border: 1px solid rgba(250, 220, 30, 1);
            }
            .number {
              float: left;
              line-height: 27px;
              span {
                color: #e84233;
              }
            }
          }
        }
        .exam_list_child {
          .child_list {
            border-top: 1px solid #eee;
            padding: 32px 0 32px 34px;
            .child_name {
              float: left;
              font-size: 14px;
              font-weight: 500;
              color: rgba(102, 102, 102, 1);
            }
            .btn_box {
              float: right;
              .number {
                float: left;
                font-size: 12px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #000;
                line-height: 27px;
                span {
                  color: rgba(254, 76, 75, 1);
                }
              }
              .btn {
                cursor: pointer;
                margin-left: 24px;
                float: left;
                width: 72px;
                height: 25px;
                background: rgba(250, 220, 30, 1);
                border-radius: 4px;
                border: 1px solid rgba(250, 220, 30, 1);
                font-size: 12px;
                font-weight: 500;
                color: rgba(0, 0, 0, 1);
                text-align: center;
                line-height: 25px;
              }
            }
          }
        }
      }
    }
  }
}
.main_kjc {
  .bread_nav {
    padding: 12px 0 12px 74px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(238, 238, 238, 1);
    margin-bottom: 16px;
    .return {
      font-size: 16px;
      font-weight: 500;
      color: rgba(43, 43, 43, 1);
      float: left;
      margin-right: 45px;
      line-height: 28px;
      cursor: pointer;
      img {
        float: left;
        width: 28px;
        height: 28px;
        margin-right: 12px;
      }
    }
    .el-breadcrumb {
      float: left;
      margin-top: 8px;
    }
  }
  .content_box {
    .content_box_l {
      float: left;
      width: 268px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      .content_box_l_title {
        padding: 24px 0;
        border-bottom: 1px solid #eee;
        text-align: center;
        font-size: 20px;
        font-weight: 500;
        color: rgba(43, 43, 43, 1);
        margin-bottom: 20px;
      }
      .class_list {
        padding: 20px 0;
        text-align: center;
        font-size: 16px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        cursor: pointer;
      }
      .active {
        font-weight: 500;
        color: rgba(43, 43, 43, 1);
        background: #0CD56D;
      }
    }
    .content_box_r {
      float: right;
      padding: 0 50px 50px 50px;
      width: 1268px;
      background: rgba(255, 255, 255, 1);
      border-radius: 4px;
      border: 1px solid rgba(238, 238, 238, 1);
      .exam_title {
        font-size: 20px;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        padding: 24px 0;
        border-bottom: 1px solid #eee;
      }
      .exam_list {
        border-bottom: 1px solid #eee;
        .exam_list_box {
          padding: 30px 0;
          .exam_list_l {
            cursor: pointer;
            .tag {
              float: left;
              width: 23px;
              height: 23px;
              background: rgba(238, 238, 238, 1);
              border-radius: 50%;
              // margin-right: 11px;
              margin-left: 11px;
              text-align: center;
              line-height: 23px;
              img {
                width: 12px;
                height: 12px;
              }
            }
            .name {
              float: left;
            }
          }

          .operate {
            float: right;
            .btn {
              cursor: pointer;
              width: 72px;
              height: 25px;
              background: rgba(0, 69, 96, 0.04);
              border-radius: 4px;
              border: 1px solid rgba(204, 204, 204, 1);
              font-size: 12px;
              font-weight: 500;
              color: rgba(0, 0, 0, 1);
              text-align: center;
              line-height: 25px;
              float: left;
              margin-left: 24px;
            }
            .huang {
              background-color: #0CD56D;
              border: 1px solid #0CD56D;
            }
            .number {
              float: left;
              line-height: 27px;
              span {
                color: #e84233;
              }
            }
          }
        }
        .exam_list_child {
          .child_list {
            border-top: 1px solid #eee;
            padding: 32px 0 32px 34px;
            .child_name {
              float: left;
              font-size: 14px;
              font-weight: 500;
              color: rgba(102, 102, 102, 1);
            }
            .btn_box {
              float: right;
              .number {
                float: left;
                font-size: 12px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #000;
                line-height: 27px;
                span {
                  color: rgba(254, 76, 75, 1);
                }
              }
              .btn {
                cursor: pointer;
                margin-left: 24px;
                float: left;
                width: 72px;
                height: 25px;
                background: #0CD56D;
                border-radius: 4px;
                border: 1px solid #0CD56D;
                font-size: 12px;
                font-weight: 500;
                color: rgba(0, 0, 0, 1);
                text-align: center;
                line-height: 25px;
              }
            }
          }
        }
      }
    }
  }
}
</style>